import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { Bubble, Thread, ThreadWrapper } from './styles';
import { TaskMessageType } from '@/types/dashboardTypes';
import { formatDate, FULL_DATE_TIME_FORMAT } from '@/helpers/dateHelpers/dateHelpers';
import { COLORS } from '@/styles/colors';
import { useEffect, useRef } from 'react';

type TasksChatType = {
  thread: TaskMessageType[];
  currentUserId: string;
};

export const TasksChat = ({ thread, currentUserId }: TasksChatType) => {
  const chatContainerRef = useRef(null);
  const messagesContainerRef = useRef(null);

  useEffect(() => {
    // Whenever new messages renders we move scroll position to bottom to avoid render jumping
    const callback = function (mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          chatContainerRef.current.scrollTo(0, chatContainerRef.current.scrollHeight);
        }
      }
    };

    const messageListObserver = new MutationObserver(callback);

    messageListObserver.observe(messagesContainerRef.current, { childList: true });

    // On chat initial render move scroll position to bottom
    chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;

    return () => {
      messageListObserver.disconnect();
    };
  }, []);

  return (
    <>
      <Box padding='12px 16px' borderBottom='1px solid #DCE3E0'>
        <Typography variant='bodySmall' fontWeight='semibold'>
          Conversation
        </Typography>
      </Box>
      <ThreadWrapper ref={chatContainerRef}>
        <Thread ref={messagesContainerRef}>
          {thread.map((message) => (
            <Bubble key={message.id} $mine={message.author_id === currentUserId}>
              <Typography variant='caption' fontWeight='medium' color={COLORS.grey[400]}>
                {message.author_label} · {formatDate(message.date_created, FULL_DATE_TIME_FORMAT)}
              </Typography>
              {message.text}
            </Bubble>
          ))}
        </Thread>
      </ThreadWrapper>
    </>
  );
};
